export function catalogLoginHelper() {
    for (let itemboxButton of document.querySelectorAll('.itembox button')) {
        itemboxButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
        })
    }
}